$(function () {
    if ($('div.waitlist-frequency').length > 0) {

        window.app = window.app || {}; // don't overwrite existing var if already exists

        window.app.Waitlist_UpdateFrequency = function (IsSchoolAge) {
            if (IsSchoolAge) {
                $(".preschool").each(function () {
                    $(this).addClass("d-none");
                });

                $(".schoolage").each(function () {
                    $(this).removeClass("d-none");
                });
            } else {
                $(".preschool").each(function () {
                    $(this).removeClass("d-none");
                });

                $(".schoolage").each(function () {
                    $(this).addClass("d-none");
                });

                $(".tickfull").each(function () {
                    $(this).prop("checked", false);
                });
            }
        }

        // Select All only applies when the age group is not school age
        // So we only check am and pm
        $("#frequencySelectAll").change(function () {
            var isChecked = $(this).is(":checked");
            $(".tickam, .tickpm").each(function () {
                $(this).prop("checked", isChecked);
            });
        });

        $(".tick").change(function () {
            var allSelected = true;

            $(".tickam, .tickpm").each(function () {
                if (!$(this).is(":checked")) {
                    allSelected = false;
                    return false;
                }
            });

            $("#frequencySelectAll").prop("checked", allSelected);
        });

    } // if ($('div.waitlist-frequency').length > 0) {
}); // $(function () {